import { render } from "./re-direct-links.vue?vue&type=template&id=e3f7bd02&scoped=true"
import script from "./re-direct-links.vue?vue&type=script&lang=js"
export * from "./re-direct-links.vue?vue&type=script&lang=js"

import "./re-direct-links.vue?vue&type=style&index=0&id=e3f7bd02&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3f7bd02"]])

export default __exports__